export class FlattenedPermission {
  public name;
  public accessGranted: boolean = false;

  constructor(name: string) {
    this.name = name;
  }

  public setAccessGranted(permissionGranted: boolean): void {
    this.accessGranted = permissionGranted;
  }
}
